import { useContext, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaStar } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import UserContext from '../../contexts/UserContext';
import apiClient, { IMAGE_BASE_URL } from '../../utils/api-client';
import PageHeader from './../Common/PageHeader';
const OrderDetails = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { orderId } = useParams();
  const [orderDetail, setOrderDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const { user } = useContext(UserContext);

  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(null);
  const [ratingDescription, setRatingDescription] = useState('');
  const [selectedProductId, setSelectedProductId] = useState(null);

  const userId = localStorage.getItem('userID');
  const userData = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

  const fetchOrderDetails = () => {
    const fetchOrderDetail = async () => {
      try {
        const response = await apiClient.get(`/order-details/${orderId}`);
        setOrderDetail(response.data.data);
        setIsLoading(false);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchOrderDetail();
  };

  const addReviewHandler = (e) => {
    e.preventDefault();

    let review = {
      p_id_fk: selectedProductId,
      user_id_fk: userId,
      rating: rating,
      reviews: ratingDescription,
    };

    apiClient
      .post('/add-review', review)
      .then((response) => {
        if (response.data.status == true) {
          toast.success(response.data.message);
          fetchOrderDetails();
          setShow(false);
          setRating(5);
          setRatingDescription('');
          setSelectedProductId(null);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  console.log('orderDetails', orderDetail);

  return (
    <>
      <PageHeader title="My Order" />
      <section className="container-fluid my-4">
        {error && <div>Error: {error}</div>}
        <div className="mb-5 text-center">
          <h2 className="fw-bold">Order Detail</h2>
          <hr className="mx-auto w-25" />
          <p className="mt-3 px-md-5">
            Have your purchased product items details summed up with taxes and
            delivery charges with an error-free total. Bakumia lets you enjoy
            online shopping without any difficulty.
          </p>
        </div>

        <div className="table-responsive bg-white">
          <style>{`
            /* Purple Button */
            .btn-purple {
              background-color: #800080;
              border: none;
            }
            .btn-purple:hover {
              background-color: #6a006a;
            }

            /* Images */
            .product-img {
              max-width: 40px;
              max-height: 40px;
              border: 1px solid purple;
              object-fit: contain;
            }

            /* Truncate text for mobile */
            .text-truncate {
              max-width: 120px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            /* Center vertically */
            .align-middle {
              vertical-align: middle;
            }

            /* Make table scrollable and full-width on small screens */
            @media (max-width: 768px) {
              .table-responsive {
                overflow-x: auto;
                -webkit-overflow-scrolling: touch; /* smooth scroll */
              }

              table {
                min-width: 700px; /* force horizontal scroll */
              }
            }

          `}</style>

          <table className="table table-striped table-hover text-start align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Product</th>
                <th>Name</th>
                <th>Color</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Total</th>
                {orderDetail.status_id_fk === 3 && <th>Rating</th>}
              </tr>
            </thead>

            <tbody>
              {isLoading && (
                <tr>
                  <td colSpan="7" className="py-3">
                    <Skeleton count={5} height={40} />
                  </td>
                </tr>
              )}

              {orderDetail?.order_detail?.length > 0 &&
                orderDetail.order_detail.map((orderItem, index) => (
                  <tr key={index}>
                    {/* Product Image */}
                    <td>
                      <img
                        src={`${IMAGE_BASE_URL}/${orderItem.varients[0].product.product_image}`}
                        alt={orderItem.varients[0].product.product_name}
                        className="product-img rounded"
                      />
                    </td>

                    {/* Product Name */}
                    <td className="text-truncate">
                      {orderItem.varients[0].product.product_name}
                    </td>

                    {/* Color */}
                    <td>{orderItem.varients[0].p_v_name}</td>

                    {/* Price */}
                    <td className="fw-semibold text-success">
                      Rs {orderItem.varients[0].final_price}
                    </td>

                    {/* Quantity */}
                    <td>{orderItem.quantity}</td>

                    {/* Total */}
                    <td className="fw-bold">
                      Rs {orderItem.total_cost * orderItem.quantity}
                    </td>

                    {/* Rating / Review */}
                    {orderDetail.status_id_fk === 3 && (
                      <td>
                        {orderItem.varients[0].product.product_review ? (
                          <span className="fw-semibold text-warning">
                            <i className="fa fa-star" />{' '}
                            {orderItem.varients[0].product.product_review.rating.toFixed(
                              1
                            )}
                          </span>
                        ) : (
                          <button
                            className="btn btn-purple btn-sm text-white"
                            onClick={() => {
                              handleShow();
                              setSelectedProductId(
                                orderItem.varients[0].product.product_id
                              );
                            }}
                          >
                            Write Review
                          </button>
                        )}

                        {/* Review Modal */}
                        <Modal
                          show={show}
                          onHide={handleClose}
                          scrollable
                          centered={false}
                          size="md"
                        >
                          <form
                            onSubmit={(e) =>
                              addReviewHandler(
                                e,
                                orderItem.varients[0].product.id
                              )
                            }
                          >
                            {/* HEADER */}
                            <Modal.Header closeButton className="border-0">
                              <Modal.Title className="fw-bold fs-5 text-dark">
                                Write a Review
                              </Modal.Title>
                            </Modal.Header>

                            {/* BODY */}
                            <Modal.Body className="px-3">
                              <p className="text-muted small mb-3">
                                Share your experience as{' '}
                                <span className="fw-semibold">
                                  {userData.full_name}
                                </span>
                                .
                              </p>

                              {/* Review Textarea */}
                              <textarea
                                rows={4}
                                autoFocus
                                className="form-control mb-3 shadow-sm rounded-3"
                                name="reviews"
                                id="reviews"
                                placeholder="Write your honest review here..."
                                value={ratingDescription}
                                onChange={(e) =>
                                  setRatingDescription(e.target.value)
                                }
                              />

                              {/* Rating Stars */}
                              <div className="d-flex justify-content-center gap-2 mb-2">
                                {[...Array(5)].map((_, index) => {
                                  const currentRating = index + 1;
                                  return (
                                    <label key={currentRating}>
                                      <input
                                        type="radio"
                                        name="rating"
                                        className="d-none"
                                        value={currentRating}
                                        onClick={() => setRating(currentRating)}
                                      />
                                      <FaStar
                                        size={30}
                                        style={{
                                          cursor: 'pointer',
                                          transition: '0.2s',
                                        }}
                                        color={
                                          currentRating <= (hover || rating)
                                            ? '#ffc107'
                                            : '#e4e5e9'
                                        }
                                        onMouseEnter={() =>
                                          setHover(currentRating)
                                        }
                                        onMouseLeave={() => setHover(null)}
                                      />
                                    </label>
                                  );
                                })}
                              </div>
                            </Modal.Body>

                            {/* FOOTER */}
                            <Modal.Footer className="border-0 pt-0">
                              <button
                                type="submit"
                                className="btn btn-purple text-white px-4 shadow-sm"
                              >
                                Submit Review
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-secondary px-4"
                                onClick={handleClose}
                              >
                                Cancel
                              </button>
                            </Modal.Footer>
                          </form>
                        </Modal>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default OrderDetails;
